import { AbstractControl } from '@angular/forms';
import * as moment from 'moment';

export function returnDateValidator(c: AbstractControl): { [key: string]: boolean } | null {
    let isReturn = c.get('isReturn').value;
    let departureDate = c.get('departureDate').value;
    let returnDate = c.get('returnDate').value;

    if(isReturn && !returnDate){
        return { 'isReturnAndNoReturnDate': true };
    }

    if(isReturn){
        var isAfter = moment(returnDate).add(1,'second').isAfter(departureDate);
        if(!isAfter){
            return { 'isReturnAndReturnDateBeforeDeparture': true };
        }
    }
    // //if (stateControl.pristine || postcodeControl.pristine) {
    // //    return null;
    // //}

    // if (countryControl.value != 'Australia') {
    //     return null;
    // } else if (stateControl.value == '' || postcodeControl.value == '') {
    //     return { 'address': true };
    // }
    return null;
}


// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/return-date.validator.ts